import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import { Container, Typography } from "@mui/material";
import Layout from "../../components/common/Layout";
import { ThinUnderlineText } from "../../components/common/StyledComponents";

export default function TermsOfUse() {
  const { t } = useTranslation(["common"]);

  return (
    <Layout>
      <Container sx={{ marginTop: "20vh", marginBottom: "5vh" }}>
        <Typography variant="h3">{t("terms_of_use")}</Typography>

        <Typography
          fontFamily={"Inter"}
          variant="h6"
          mt={6}
          className="lineBreak"
        >
          Welcome to Naturethings. We are so glad you are here. 🥳 Make yourself
          at home 🏡 and have a good time, but please follow our Terms of Use.
          Please read these Terms of Use (“Terms”) carefully as they contain
          important information about your legal rights, remedies and
          obligations.
          {"\n"}
          By accessing or using the Naturethings Platform, you agree to comply
          with and be legally bound by these Terms.
          {"\n"}
          {"\n"}1. These Terms
          {"\n"}
          1.1 These Terms constitute a legally binding agreement (“Agreement”)
          between you and All Nature Things Pte Ltd (“Naturethings”) governing
          your access to and use of our platform, including our web app(s),
          website(s), our application(s), our application programming interfaces
          (“APIs”), our notifications and any information or content appearing
          therein (collectively referred to as our “Platform”).
          {"\n"}
          1.2 By using our Platform, you agree to these Terms regardless of
          whether you are a supplier of goods or services (referred to as
          “Seller”), paying user or a non-paying visitor. If you are using our
          Platform as a representative of an entity, you are agreeing to these
          Terms on behalf of that entity. You further agree that by (1) using
          the Platform’s website, mobile site, or any other related sites or
          services, whether or not you join the Platform; (2) creating a
          Platform account, or (3) otherwise indicating your acceptance of this
          Agreement, you are legally bound by its Terms.
          {"\n"}
          1.3 If you disagree with, or do not intend to abide by, any of the
          Terms of this Agreement or any future amendments, you must delete your
          account and refrain from using Naturethings Platform.
          {"\n"}
          1.4 When these Terms mention Naturethings, we, us, or our, it refers
          to the corporation All Nature Things Pte Ltd and any of its parents,
          subsidiaries, agents, or related organisations.
          {"\n"}
          1.5 By accessing our Platform, you also agree to our Privacy Policy,
          available at https://www.getnaturethings.com/privacy_policy, which
          sets out how we collect, process and use your personal information.
          You also hereby acknowledge that you have read our Privacy Policy and
          provide your acceptance to our collection, processing and rights of
          use of your personal information.
          {"\n"}
          {"\n"}2. About us and how to contact us
          {"\n"}
          2.1 We are All Nature Things Pte Ltd, a company registered UEN
          202113379K in Singapore, trading as Naturethings.
          {"\n"}
          2.2 For any questions or problems relating to our Platform, our
          products or services, or these Terms, you can contact us by emailing
          us at eva@Naturethings.co or writing to us at All Naturethings Pte
          Ltd, 1 North Bridge Road, #12-09, High Street Center, Singapore,
          179094.
          {"\n"}
          2.3 We are the data controller in relation to our Platform for the
          collection, processing and use of your personal information. Please
          refer to our Privacy Policy, available at
          https://www.getnaturethings.com/privacy_policy, for information about
          what personal data we collect, process and the rights of usage. It is
          important that you read our Privacy Policy, which may be updated from
          time to time, and understand how we use your information and the
          rights that we have about your information.
          {"\n"}
          2.4 If we have to contact you, we will do so by telephone or by
          writing to you at the email address or postal address you provided to
          us.
          {"\n"}
          2.5 When we use the words writing or written in these Terms, this
          includes emails or any other form of written communication whether
          physical or digital.
          {"\n"}
          {"\n"}3. Changes of Terms
          {"\n"}
          3.1 We may amend these Terms from time to time by posting the updated
          Terms on our Platform. If we make material changes, we may notify you
          via email of the changes before they become effective, if we deem fit
          in our sole discretion. By continuing to use our Platform and our
          services after the changes come into effect means that you agree to be
          bound by the revised Terms.
          {"\n"}
          {"\n"}4. Availability of our services
          {"\n"}
          4.1 We are constantly changing and improving our Platform and the
          products or services we provide. We may, from time to time, change or
          discontinue any of the products or services that we offer, or add or
          remove functionalities or features, and we may suspend or stop certain
          products, services, functionalities or features altogether. If we
          discontinue certain products, services, functionalities or features,
          we will take reasonable endeavours to provide you with an advance
          notice via email where reasonably possible, as we may deem fit in our
          sole discretion.
          {"\n"}
          4.2 We may release products, services, functionalities or features
          that we are still testing and evaluating. We may label such services
          as “beta”, “preview”, “early access” or “trial” or any words or
          phrases with similar meanings. You understand that these beta services
          are not as reliable as other products or services we offer.
          {"\n"}
          4.3 We reserve the right to limit your use of our Platform and the
          services we provide, including the right to modify, restrict, suspend
          or terminate your account if we believe you are in breach of these
          Terms or are misusing our Platform or any services we provide.
          {"\n"}
          4.4 We will take reasonable endeavours to ensure that our Platform is
          always available, but we do not guarantee that the operation of or
          access to our Platform will be uninterrupted, error free or
          continuous. Our Platform may be subject to interruption for
          maintenance, repairs, upgrades, network, equipment failures or by acts
          of God, that are not within our control.
          {"\n"}
          4.5 You are responsible for configuring your information technology,
          computer programs and platform or system in order to access our
          Platform. We do not guarantee that our Platform will be free from bugs
          or viruses.
          {"\n"}
          {"\n"}5. Your account and password
          {"\n"}
          5.1 While registering for an account on our Platform, you must provide
          truthful, accurate and up-to-date information about yourself or the
          entity that we represent. You should choose a strong and secure
          password (in line with the up-to-date guidelines indicated on the
          platform and in accordance with the applicable laws, if any). You must
          keep your password secure and confidential.
          {"\n"}
          5.2 You agree not to share your account credentials or give others
          access to your account. If and when we detect that an account is
          shared by multiple users, we may treat this as a security breach and
          suspend or terminate your account.
          {"\n"}
          5.3 We have the right to disable any password, whether chosen by you
          or allocated by us, at any time, if in our reasonable opinion you are
          in breach of these Terms.
          {"\n"}
          5.4 You agree to follow our Acceptable Use Policy, which is set out at
          the end of these Terms.
          {"\n"}
          5.5 You are responsible for all actions or activities that happen by,
          through or under your account, unless you report misuse.
          {"\n"}
          5.6 You shall immediately and in no case later than twenty-four (24)
          hours notify us in case any security breach, unauthorized access to
          your account or any beach of the security or usage guidelines as
          mentioned under these Terms
          {"\n"}
          {"\n"}6. Use of the Platform
          {"\n"}
          6.1 You must comply with the Acceptable Use Policy and all applicable
          laws and regulatory requirements, including privacy laws and
          intellectual property laws while using or accessing the Platform.
          {"\n"}
          6.2 We give you a limited, personal, worldwide, non-assignable,
          non-transferrable, non- sub licensable, non-exclusive and revocable
          license to access and use our Platform, including any software or
          application as part of the services we offer. This license is for the
          sole purpose of enabling you to use and enjoy the benefits of our
          Platform, as provided by us and in the manner as permitted by these
          Terms.
          {"\n"}
          6.3 This license to use our Platform will terminate if you do not
          comply with these Terms, applicable laws or other additional terms or
          conditions imposed by us from time to time.
          {"\n"}
          6.4 You must not copy, modify, distribute, sell, lease, loan or trade
          any access to the Platform or any data or information on it.
          {"\n"}
          6.5 You shall not (a) not introduce any computer viruses or malicious
          items on the Platform; (b) not reverse compile, disassemble, reverse
          engineer our Platform or any other software provided by us; (c) not
          re-order, modify, edit obscure or truncate in anyway the contents,
          graphics, format, audio, video, sequence, or any aspect of the
          Platform; and (d) not engage in any fraudulent activities or illegal
          practices using the Platform.
          {"\n"}
          {"\n"}7. Your rights
          {"\n"}
          7.1 You retain your rights to any text, graphics, images, information,
          opinions you submit, share, post, display, render on or through the
          Platform (“Your Content”). By submitting, sharing, posting or
          displaying such content, you grant us a worldwide, non-exclusive,
          royalty-free, perpetual license (with the right to sublicense) to use,
          process, copy, reproduce, adapt, modify, publish, transmit, display
          and distribute Your Content in any and all media or through any
          distribution channels (now known or later developed), subject to the
          applicable provisions in our Privacy Policy.
          {"\n"}
          7.2 You are responsible for your use, consent requirements and
          licensing of Your Content and any consequences thereof, including any
          consequences of the use of Your Content by other users or third
          parties. We are not responsible or liable, in any manner, for any use
          of Your Content, nor the use of any content or information submitted
          or posted by other users or visitors.
          {"\n"}
          7.3 You warrant that Your Content is not and will not infringe rights
          of any third parties and that you have all the necessary rights, power
          and authority to satisfy your obligations with regard to Your Content
          under these Terms.
          {"\n"}
          7.4 If you believe your intellectual property rights have been
          infringed, please contact us by writing to us at eva@naturethings.co
          {"\n"}
          {"\n"}8. Our role and rights
          {"\n"}
          8.1 Naturethings is a marketplace comprised of individual third-party
          suppliers, service providers (collectively known as “Sellers”) who run
          their own listings, shops, create their own policies, and are
          responsible for their goods, services, listings, contents etc.
          complying with the applicable laws. We provide a marketplace, but
          Naturethings does not manufacture goods, hold inventory, or ship items
          on behalf of our Sellers. The content uploaded on Naturethings
          marketplace is generated by independent Sellers who are not employees,
          agents, or representatives of Naturethings. Sellers are responsible
          for ensuring they have all necessary rights to their content and that
          they are not infringing or violating any third party’s rights by
          posting it.
          {"\n"}
          8.2 All intellectual property rights subsisting in the Platform or the
          products or services we provide belong to us or have been lawfully
          licensed to us. All rights under applicable laws are hereby reserved.
          You must not upload, post, publish, reproduce, transmit or distribute
          any content or component of our Platform in any way, or create any
          derivative works with respect to any such content or component.
          {"\n"}
          8.3 We may (at our sole discretion but are not obliged to) review
          content or information submitted or posted by users on our Platform.
          We reserve the right to remove any content which we consider as
          offensive, harmful, deceptive, discriminative, defamatory or otherwise
          inappropriate or misleading, or content that we believe may be
          infringing rights of third parties. We do not endorse or support any
          views expressed by any users on our Platform.
          {"\n"}
          8.4 Our name “Naturethings” and our marks and logos are our trademarks
          (be it registered or unregistered) and may not be used, for any
          purposes, without our express prior written consent.
          {"\n"}
          {"\n"}9. Integrations
          {"\n"}
          9.1 We integrate with third-party software to provide a full suite of
          functionalities to our users. We are not responsible for any issues or
          loss arising from the use of any third-party software. Your access and
          use of the third-party software is governed by the terms of service or
          user agreements of that software.
          {"\n"}
          {"\n"}10. Feedback
          {"\n"}
          10.1 We value and welcome feedback on our Platform. You agree that we
          are free to use, disclose, adopt and/or modify any feedback and any
          information (including any ideas, concepts, proposals, suggestions or
          comments) provided by you to use in connection with our Platform or
          any products or services we offer, without any payment to you.
          {"\n"}
          10.2 You hereby waive and agree to waive any rights to claim for any
          fees, royalties, charges or other payments in relation to our use,
          disclosure, adoption and/or modification of any of your feedback.
          {"\n"}
          {"\n"}11. Limitation on liabilities
          {"\n"}
          11.1 To the fullest extent permitted by law, we (including our holding
          company(ies), subsidiaries, affiliates, directors, officers,
          employees, agents, representatives, partners and licensors
          (collectively, “Our Entities”) expressly limit our liabilities in
          connection with or arising out of the provision of the Platform as
          follows:
          {"\n"}
          (a) we provide the Platform and any products or services we offer on
          an “as is” and “as available” basis, and your access to or use of our
          Platform is at your own risk;
          {"\n"}
          (b) we give no assurance, representation or warranty of any kind
          (whether express or implied) about the Platform and any products or
          services we provide;
          {"\n"}
          (c) we do not guarantee that the information or content you find on
          the Platform is always accurate, truthful, complete and up-to-date;
          {"\n"}
          (d) we expressly disclaim all warranties and representations (for
          example, warranties of merchantability, fitness for a particular
          purpose, and non-infringement);
          {"\n"}
          (e) we are not responsible for any delay or disruption in our Platform
          or any defect, viruses, bugs or errors; and
          {"\n"}
          (f) we are not responsible for the conduct of or any content or
          information submitted or posted by any user of the Platform (whether
          online or offline).
          {"\n"}
          11.2 To the fullest extent permitted by law, our Entities are not
          liable to you or others for:
          {"\n"}
          (a) any indirect, incidental, special, exemplary, consequential or
          punitive damages; or
          {"\n"}
          (b) any loss of data, business, opportunities, reputation, profits or
          revenues relating to the use of our Platform or any products or
          services we offer.
          {"\n"}
          11.3 Other than the types of liabilities that we cannot limit by the
          applicable laws, the liabilities of Our Entities to you (on aggregate)
          are limited to the amount you have paid us (if any) for the use of our
          Platform or for any products or services we offer over the last twelve
          (12) months.
          {"\n"}
          {"\n"}12. Your representation
          {"\n"}
          12.1 Our Platform is not intended for and may not be used by minors.
          By using our Platform, you represent that you are an adult, as defined
          under the applicable laws, that you are eligible to legally enter into
          contractual agreements and are not barred under the applicable laws to
          enter into any contractual obligations.
          {"\n"}
          12.2 If you are using the Platform on behalf of an entity, by using
          the Platform you represent that you have the necessary rights,
          licenses and authority to agree to these Terms (and our Privacy
          Policy, Acceptable Use Policy and other documents referred to herein)
          on behalf of that entity.
          {"\n"}
          {"\n"}13. Indemnity
          {"\n"}
          13.1 You agree to indemnify and hold Our Entities harmless from and
          against all liabilities, damages, fines, penalties, claims, costs
          (including legal fees and costs), and expenses in connection with or
          arising from
          {"\n"}
          (a) your breach of these Terms, including in particular infringement
          of any third-party intellectual property rights, or
          {"\n"}
          (b) your use of our Platform and/or (iii) any misrepresentation made
          by you.
          {"\n"}
          13.2 You also agree to fully cooperate with us in the defense or
          settlement of any claim in relation to or arising out of our Platform
          or these Terms.
          {"\n"}
          {"\n"}14. Term and Termination
          {"\n"}
          14.1 These Terms shall commence from the time you start accessing the
          Platform.
          {"\n"}
          14.2 These Terms shall continue to apply until terminated by either
          you or us in accordance with these Terms.
          {"\n"}
          14.3 You may stop using the Platform anytime by deactivating your
          account.
          {"\n"}
          14.4 We reserve the right to suspend or terminate your access to our
          Platform, if we reasonably believe:
          {"\n"}
          (a) you are in serious or repeated breach of these Terms (including a
          prolonged failure to settle any payment);
          {"\n"}
          (b) you are using the Platform in a manner that would cause a real
          risk of harm or loss to us, other users, other sellers, or the public;
          {"\n"}
          (c) we are requested to do so by government or regulatory authorities
          or as required under applicable laws, regulations or legal processes;
          or
          {"\n"}
          (d) our provision of the Platform to you is no longer possible or
          commercially viable.
          {"\n"}
          In any of the above cases, we shall take reasonable endeavours to
          notify you by the email address associated with your account or at the
          next time you attempt to access your account, unless we are prohibited
          from notifying you by law, as we may deem fit in our sole discretion.
          {"\n"}
          14.5 Upon termination of your access, these Terms will also terminate
          except for Clauses 11 to 18.
          {"\n"}
          14.6 Where we consider necessary or appropriate, we will report any
          breach of these Terms (or the Acceptable Use Policy) to law
          enforcement authorities, and we will cooperate with such authorities
          by disclosing your identity and providing any information about you
          within our systems to them.
          {"\n"}
          {"\n"}15. Entire agreement
          {"\n"}
          15.1 These Terms constitute the entire agreement between you and us in
          relation to the use of or any transactions on the Platform. These
          Terms supersede, override and extinguish all other agreements,
          promises, assurances, warranties, representations and understandings
          between you and us, whether written or oral, in relation to the use of
          or any transactions on the Platform.
          {"\n"}
          15.2 You acknowledge that you will have no remedies or waive any
          remedy available under the applicable laws, if any, in respect of any
          statement, representation, assurance or warranty (whether made
          innocently or negligently) that is not set out in these Terms.
          {"\n"}
          {"\n"}16. Other important terms
          {"\n"}
          16.1 We may transfer our rights and obligations under these Terms to
          any another organisation. We may contact you via email to let you know
          if we plan to do this. If you do not wish to continue the contract
          with the transferee, you may contact us to end the contract within one
          (1) calendar month of us informing you of the proposed transfer and we
          will refund you any payments you have made in advance for any products
          not provided.
          {"\n"}
          16.2 You may only transfer your rights or your obligations under these
          Terms to another person if we agree to this in writing.
          {"\n"}
          16.3 If a court finds part of this contract illegal, the rest will
          continue in force. Each of the paragraphs of these Terms operates
          separately. If any court or relevant authority decides that any of
          them are unlawful, the remaining paragraphs will remain in full force
          and effect.
          {"\n"}
          16.4 Even if we delay in enforcing these Terms, we can still enforce
          it later. If we do not insist immediately that you do anything you are
          required to do under these Terms, or if we delay in taking steps
          against you in respect of your breaking this contract, that will not
          mean that you do not have to do those things and it will not prevent
          us taking steps against you at a later date. For example, if you miss
          a payment and we do not claim the same from you immediately but we
          continue to provide the products or services, we can still require you
          to make the payment at a later date.
          {"\n"}
          {"\n"}17. Contact
          {"\n"}
          17.1 If you have any questions about these Terms or the Acceptable Use
          Policy, please contact us by email on eva@naturethings.co
          {"\n"}
          {"\n"}18. Governing law and dispute resolution
          {"\n"}
          18.1 These Terms are governed by and shall be construed in accordance
          with the laws of the Republic of Singapore.
          {"\n"}
          18.2 All disputes related to this agreement will be filed and heard
          exclusively by the courts of Singapore.
          {"\n"}
          {"\n"}19. Fees, billing, and payment
          {"\n"}
          19.1 Users of the Service will be required to provide their credit
          card and/or bank account information (“Account”) to Naturethings and
          the Payment Service Provider(s) retained/ integrated into the Platform
          by Naturethings (collectively, the “PSP”). Customers will be
          responsible for paying the invoice of each transaction (the
          “Invoice”), which will include the pricing Terms of the transaction as
          communicated by the Seller on the Platform (the “Payment”).
          {"\n"}
          19.2 Sellers may be required to register with the PSP, agree to the
          Terms of the service of the PSP and go through a vetting process by
          the PSP to set up their account with the PSP in accordance with the
          Terms and conditions as set out the PSP (the “PSP agreement”). The
          information and access provided to the PSP as per the PSP Agreement is
          agreed upon and entered into by the Seller directly. Please note that
          Naturethings has no obligations or liability to the Seller under the
          PSP Agreement.
          {"\n"}
          19.3 By registering for an Account, you expressly authorize
          Naturethings to process each Payment and any fees owed to Naturethings
          for the use of services incurred under your Account. You may be
          charged a cancellation fee through the PSP if you book a transaction
          but cancel such a transaction before it is completed. Naturethings
          reserves the right, in its sole discretion (but not the obligation),
          to (i) place a hold on any transaction, or (ii) refund, provide credit
          or arrange for the PSP to do so.
          {"\n"}
          {"\n"}20. Purchase terms
          {"\n"}
          20.1 Once you purchase the product, the order shall be considered as
          confirmed. However, if for any reason, the Seller is unable to accept
          your booking or deliver the product, Naturethings will refund the
          payment within seven (7) working days.
          {"\n"}
          {"\n"}21. Returns, Refunds, Exchange and Cancellations Policy
          {"\n"}
          21.1 Damages and issues
          {"\n"}
          Please inspect your order upon receiving and contact us immediately if
          the item is defective, damaged or if you receive the wrong item/ items
          are missing from your order, so that we can evaluate the issue and
          help you with an exchange or shipment of the missing parts.
          {"\n"}
          21.2 Partial Deliveries
          {"\n"}
          In case of partial deliveries, i.e. if some products from your order
          are missing, please contact us on eva@naturethings.co with the details
          of the order and the missing product/s, and we will ship the same to
          you. No exchange, return or refund request will be accepted due to
          incomplete orders. Only if NatureThings is unable to fulfil the
          incomplete/ missing item/s, refund pertaining to the missing items
          will be provided.
          {"\n"}
          21.3 Returns and Exchanges
          {"\n"}
          (a) We do not allow return or exchange of any product or service
          purchased on our Platform. Only in cases where a damaged product is
          received, or products other than those ordered are received, we will
          allow a forty-eight (48) hour return policy.
          {"\n"}
          (b) To be eligible for a return, your item must be in the same
          condition that you received it, unworn and unused, with tags (if any),
          and in its original packaging intact. You will also need the receipt
          or proof of purchase, and the request must be raised within 48 hours
          of receiving the delivery.
          {"\n"}
          (c) To start a return, you can contact us at team@naturethings.co. If
          your return is accepted, our logistics partner will pick up the
          product from your shipping address. Items sent back to us without
          first requesting a return will not be accepted
          {"\n"}
          The email should contain –{"\n"}• Reasons for return
          {"\n"}• Copy of invoice
          {"\n"}• Picture of the product received
          {"\n"}• Product Category Specific Policies
          {"\n"}
          21.4 Live Plants
          {"\n"}
          Please note that in the case of live plants, no two products can be
          the same. While we take utmost care in designing our catalogue, the
          products shipped will vary from the images on the site, i.e. the
          number, size and shape of branches, leaves, flowers on the plants will
          vary. Hence, differences in the pictures on the website and the
          product received in case of plants, will not be covered under the
          return, refund and exchange policy.
          {"\n"}
          21.5 Customized Products
          {"\n"}
          Customized products, i.e. products made to order, cannot be returned.
          Please get in touch with us on team@naturethings.co if you have
          questions or concerns about your specific item.
          {"\n"}
          21.6 Delayed Deliveries
          {"\n"}
          We deliver all our orders within the delivery periods as notified
          against the respective product at the time of checkout. However,
          sometimes due to unavoidable situations, the deliveries may be
          delayed. We will contact you in such cases to inform you of the same.
          No cancellation / exchange requests will be accepted due to this
          {"\n"}
          Note that Naturethings will not accept cancellation / exchange
          requests in case the delivery is delayed due to circumstances not
          controlled by Naturethings, restrictions due to Covid-19, weather
          conditions, government restrictions, etc.
          {"\n"}
          21.7 Customer Unavailability
          {"\n"}
          In case you are unavailable at the time of delivery attempt, the
          delivery executive will contact you to confirm how the goods can be
          safely delivered. Delivery reattempts can only be made once with
          additional delivery charges, and only in exceptional scenarios. Even
          if the goods remain undelivered after one (1) attempt, we will submit
          the same to the Seller. Further delivery attempts may be chargeable,
          additionally.
          {"\n"}
          21.8 Refunds
          {"\n"}
          Refund requests will be accepted only in certain cases -{"\n"}
          (a) If the payment was deducted twice for the same order/ you placed a
          duplicate order and requested cancellation on the same day.
          {"\n"}
          (b) If we are unable to fulfil your order.
          {"\n"}
          (c) If we are unable to fulfil an exchange for an eligible product.
          {"\n"}
          (d) When we have accepted your return request.
          {"\n"}
          We will notify you once we’ve received your request (in case of
          returns, post inspection of goods received), and let you know if the
          refund was approved or not. If approved, you’ll be automatically
          refunded on the payment method used to make the payment. Please
          remember it can take some time for your bank or credit card company to
          process and post the refund too.
          {"\n"}
          21.9 Third Party Terms
          {"\n"}
          We, at Naturethings, are not responsible for any refunds/ returns
          related to third party sellers/ vendors. Naturethings will only act as
          a platform between the third-party sellers and the customers and by no
          means gives guarantees / warranties on behalf of the third-party
          sellers. In case of loss of communication with the third-party
          sellers, we shall not be held responsible for fulfilment of the
          contracts between the customers and the respective sellers.
          {"\n"}
          21.10 Disputes
          {"\n"}
          In case of any disputes, arising from misinterpretation of these
          Terms, or otherwise, the decision taken by Naturethings shall be
          considered final and binding.
          {"\n"}
          {"\n"}22. Acceptable Use Policy
          {"\n"}
          As part of the Terms of use, you agree not to misuse the Platform or
          help anyone else to do so. For example, you agree not to do any of the
          following in connection with the Platform:
          {"\n"}
          (a) use our Platform for unlawful or unauthorised purposes
          {"\n"}
          (b) re-sell or attempt to benefit in a commercial fashion from any
          data, content or information available on the Platform
          {"\n"}
          (c) probe, scan, or test the vulnerability of any system or network
          {"\n"}
          (d) breach or otherwise circumvent any security or authentication
          measures or service use limits
          {"\n"}
          (e) access, tamper with, or use non-public areas or parts of the
          Platform
          {"\n"}
          (f) interfere with or disrupt any user, host, or network, for example
          by sending a virus, trojan, worm, logic bomb, or any other material
          that is malicious or technologically harmful, overloading, flooding,
          spamming, or mail-bombing any part of the Platform, or by scripting
          the creation of any content in such manner as to interfere with or
          create an undue burden on the Platform
          {"\n"}
          (g) reverse engineer, decompile, disassemble, decipher or otherwise
          attempt to derive the source code for the Platform or any related
          technology that is not open source
          {"\n"}
          (h) access, search, or create accounts for the Platform by any means
          (automated or otherwise) other than our publicly supported interfaces
          (for example, scraping or creating accounts in bulk) or attempt to do
          so
          {"\n"}
          (i) send unsolicited communications, promotions or advertisements, or
          spam
          {"\n"}
          (j) forge any TCP/IP packet header or any part of the header
          information in any email
          {"\n"}
          (k) send altered, deceptive, or false source-identifying information,
          including spoofing or phishing
          {"\n"}
          (l) conduct surveys, contests, or pyramid schemes, or promote or
          advertise products or services without appropriate authorisation
          {"\n"}
          (m) abuse referrals or promotions
          {"\n"}
          (n) post, publish, upload, display, distribute, or share materials
          that are unlawful, inappropriate, profane, pornographic, obscene,
          indecent, libelous, defamatory, abusive, or knowingly false, and/or
          that infringe intellectual property rights
          {"\n"}
          (o) violate the letter or spirit of our Terms of use
          {"\n"}
          (p) violate applicable laws or regulations in any way
          {"\n"}
          (q) violate privacy or infringe the rights of others.
          {"\n"}
          {"\n"}
          Updated March 8, 2022
        </Typography>

        <Typography fontFamily={"Inter"} variant="h6" mt={6}>
          {t("further_queries_note", { ns: "common" })}{" "}
          <Typography
            component="a"
            fontFamily={"Inter"}
            sx={{ textDecoration: "none" }}
            href="mailto:eva@naturethings.co"
            color="textPrimary"
            fontWeight="bold"
          >
            <ThinUnderlineText>eva@naturethings.co</ThinUnderlineText>
          </Typography>
        </Typography>
      </Container>
    </Layout>
  );
}

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
    },
  };
}
